import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import dompurify from "isomorphic-dompurify";
import { Loading } from "@jti/ui/components/Loading";
import InStockIcon from "@jti/ui/icons/in-stock.svg";
import OutOfStockIcon from "@jti/ui/icons/out-of-stock.svg";
import { useTranslations } from "@jti/ui/providers/useTranslations";
import { TitleBorderContainer } from "@jti/ui-library";
const { sanitize } = dompurify;
export const StockInformationBlock = ({ isInStock }) => {
    const { __ } = useTranslations();
    const rootClassName = "product-information-block__stock";
    return isInStock ? (_jsxs("div", { className: classNames(rootClassName, `${rootClassName}--in-stock`), "data-testid": "inStockBlock", children: [_jsx(InStockIcon, {}), _jsx("span", { className: `${rootClassName}--stock-text`, children: sanitize(__("product.label.instock")) })] })) : (_jsxs("div", { className: classNames(rootClassName, `${rootClassName}--out-of-stock`), "data-testid": "outOfStockBlock", children: [_jsx(OutOfStockIcon, {}), _jsx("span", { className: `${rootClassName}--stock-text`, children: sanitize(__("product.label.outofstock")) })] }));
};
export const StockStatus = ({ isInStock, isProductDataLoading }) => {
    const { __ } = useTranslations();
    return (_jsx(TitleBorderContainer, { title: __("product.label.stock"), children: isProductDataLoading ? _jsx(Loading, {}) : _jsx(StockInformationBlock, { isInStock: isInStock }) }));
};
//# sourceMappingURL=StockStatus.js.map